import { EquallyDistributed } from './EquallyDistributed';
import { Tiered as TieredComponent } from './Tiered';

// eslint-disable-next-line functional/immutable-data -- Adding sub components
const Tiered = Object.assign(TieredComponent, { EquallyDistributed });
export { EquallyDistributed, Tiered };
